/**
 * @Author Valon.Ye
 * @Date 2022/06/15 15:54:55
 * @FilePath \business\src\utils\storageMap.ts
 * @Description
 */
enum STORAGE_MAP {
  DOMAIN_PREFIX = 'bc-app-domain-prefix',
  ORG_ID = 'organization-id',
  ACCOUNT_INFO = 'account-info',
  USER_INFO = 'user-info',
  ANNOUNCEMENT_SHOW_STATUS = 'show-announcement-status',
  APP_REFER = 'x-app-refer',
}

export default STORAGE_MAP
